import { Autocomplete, Box, Grid, InputLabel, TextField } from "@mui/material";
import { INVOICE_FILTER_FIELDS } from "./InvoiceUntil";
import FormField from "../../../components/common/FormField";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  bulkInvoiceAction,
  getAllCustomerListAction,
  syncBulkInvoiceAction,
} from "../../../store/reducers/invoiceSlice";
import CustomButton from "../../../components/common/button/CustomButton";
import { getInvoiceTypeListAction } from "../../../store/reducers/quickBookSlice";
import ProgressAlert from "../../../components/common/ProgressAlert";

const FilterInvoiceForm = ({
  filterOption,
  setFilterOption,
  onHandleNewInvoice,
  onHandleNewCreditNote,
  onHandleSendEmailInvoice,
  onHandleDownloadPdf,
  selectedInvoices,
}: any) => {
  const dispatch = useDispatch();
  const { customersList, invoices } = useSelector((state: any) => state.invoice);
  const [customerOptions, setCustomerOptions] = useState<any[]>(customersList || []);
  const { invoiceTypes } = useSelector((state: any) => state?.quickBook);
  
  // Merge new API results with previous list, deduplicate, and ensure selected customer is present
  useEffect(() => {
    setCustomerOptions((prev) => {
      const merged = [...(prev || []), ...(customersList || [])];
      // Deduplicate by id
      const unique = merged.filter(
        (item, idx, arr) =>
          item &&
          item.id &&
          arr.findIndex((x) => x && x.id === item.id) === idx
      );
      return unique;
    });
  }, [customersList]);
  
  const [filter, setFilter] = useState<any>({
    search: "",
    customerId: "",
    page: 1,
    limit: 1,
    orderBy: "created_at",
    orderIn: "DESC",
  });

  useEffect(() => {
    dispatch(getAllCustomerListAction(filter));
    dispatch(getInvoiceTypeListAction());
  }, [dispatch, filter]);

  const onChangeAction = (e: any) => {
    const { id, value, checked, type } = e.target;
    setFilterOption((prevState: any) => ({
      ...prevState,
      [id]: type === "checkbox" ? checked : value,
    }));
  };

  const UPDATED_FORM_DATA = INVOICE_FILTER_FIELDS.map((field) => {
    if (field.id === "customerId") {
      return { ...field, options: customersList };
    }
    if (field.id === "invoiceType") {
      const mappedInvoiceTypes = (invoiceTypes || []).map((type: any) => ({
        label: type.name,
        id: type.name, // send label instead of ID
        tooltip: type.description || type.tooltip || "",
      }));

      const hasCredit = mappedInvoiceTypes.some(
        (type: any) => String(type?.id || "").toLowerCase() === "credit",
      );

      return {
        ...field,
        options: [
          ...mappedInvoiceTypes,
          ...(hasCredit ? [] : [{ label: "Credit", id: "Credit" }]),
          // { label: "Final", id: "Final" },
          // { label: "Deposit", id: "Deposit" },
        ],
      };
    }
    return field;
  });

  const capitalize = (str: string) =>
    str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "";

  const onHandleSendBulkInvoice = (type: string) => {
    // Implement bulk invoice sending logic here
    dispatch(
      bulkInvoiceAction({ action: type, invoiceNumbers: selectedInvoices })
    );
  };

  const [sendModelShow, setSendModelShow] = useState(false);

  const onHandleSyncBulkInvoice = () => {
    dispatch(syncBulkInvoiceAction({ invoiceNumbers: selectedInvoices }));
    setSendModelShow(true);
  };


  return (
    <>
      {sendModelShow && (
        <ProgressAlert
          show={sendModelShow}
          setShow={setSendModelShow}
        />
      )}
      <Grid container spacing={2} sx={{marginBottom:'10px'}}>
        {UPDATED_FORM_DATA &&
          UPDATED_FORM_DATA.map((field) =>
            field.id === "customerId" ? (
              <Grid item xs={12} sm={6} md={2} key={field.id}>
                <InputLabel
                  sx={{
                    color: "#637381",
                    fontWeight: 600,
                    fontSize: "16px",
                    textAlign: "left !important",
                  }}
                  shrink
                  htmlFor={field.id}
                >
                  {field.label}
                </InputLabel>
                <Autocomplete
                  options={customerOptions}
                  getOptionLabel={(option: any) => {
                    if (!option) return "";
                    return capitalize(option.name || "");
                  }}
                  value={
                    customerOptions?.find(
                      (item: any) => item.id === filterOption.customerId
                    ) || null
                  }
                  onInputChange={(_, value, reason) => {
                    if (reason === 'input') {
                      const filtered = (customerOptions || []).filter((c: any) =>
                        c.name?.toLowerCase().includes(value.toLowerCase()) ||
                        c.email?.toLowerCase().includes(value.toLowerCase())
                      );
                      if (filtered.length > 0) {
                        setCustomerOptions(filtered);
                      } else if (value.length > 1) {
                        // Call API to fetch customers by search value
                        dispatch(getAllCustomerListAction({ search: value, customerId: filterOption.customerId, page: 1, limit: 100, orderBy: "created_at", orderIn: "DESC" }));
                      }
                    } else if (reason === 'clear') {
                      setCustomerOptions(customersList || []);
                    }
                  }}
                  onChange={(_, selectedValue) => {
                    setFilterOption((prev: any) => ({
                      ...prev,
                      customerId: selectedValue ? selectedValue.id : "",
                      customer_email: selectedValue
                        ? selectedValue.email || ""
                        : "",
                      telephone: selectedValue ? selectedValue.phone || "" : "",
                    }));
                  }}
                  isOptionEqualToValue={(o, v) => o.id === v.id}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Search customer..."
                      size="small"
                      fullWidth
                    />
                  )}
                />
              </Grid>
            ) : (
              <FormField
                key={field.id}
                onKeyDown={(event: any) => {
                  if (
                    event.keyCode === 8 ||
                    event.keyCode === 9 ||
                    event.keyCode === 37 ||
                    event.keyCode === 38 ||
                    event.keyCode === 39 ||
                    event.keyCode === 40 ||
                    event.keyCode === 18 ||
                    event.keyCode === 17 ||
                    event.ctrlKey
                  )
                    return event;
                  if (
                    field?.patternAllowed &&
                    !field?.patternAllowed.test(event.key)
                  ) {
                    event.preventDefault();
                  } else if (
                    field?.patternAllowed &&
                    !field?.patternAllowed.test(event.target.value + event.key)
                  ) {
                    event.preventDefault();
                  }
                }}
                {...{
                  ...field,
                  value: filterOption ? filterOption[field.id] ?? "" : "",
                  variant: "outlined",
                  minRows: 2,
                  isNonMarginTop: true,
                  inSingleGridForm: true,
                  onChange: onChangeAction,
                  maxLength: 250,
                  InputProps: {
                    ...(field?.inputProps && field?.inputProps),
                    sx:
                      field?.type === "text" || field?.type === "password"
                        ? { height: "36px" }
                        : {
                            padding: "6px 12px",
                          },
                  },
                }}
              />
            )
          )}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <CustomButton
            title={"New Invoice"}
            sx={{ marginRight: "10px" }}
            onClick={onHandleNewInvoice}
          />
           <CustomButton
            title={"New Credit"}
            sx={{ marginRight: "10px" }}
            onClick={onHandleNewCreditNote}
          />
       
          <CustomButton
            title={"Statement Email"}
            disabled={invoices.length === 0 || !filterOption?.customer_email}
            sx={{ marginRight: "10px" }}
            onClick={onHandleSendEmailInvoice}
          />
      
        
           <CustomButton
            title={"Pdf"}
            disabled={invoices.length === 0}
            sx={{ marginRight: "10px" }}
            onClick={onHandleDownloadPdf}
          />
          <CustomButton
            title={"Email Invoices"}
            sx={{ marginRight: "10px" }}
            disabled={selectedInvoices.length === 0}
            onClick={() => onHandleSendBulkInvoice("email")}
          />
          <CustomButton
            title={"Download PDFs"}
            sx={{ marginRight: "10px" }}
            disabled={selectedInvoices.length === 0}
            onClick={() => onHandleSendBulkInvoice("download")}
          />
          <CustomButton
            title={"Sync Invoices"}
            sx={{ marginRight: "10px" }}
            disabled={selectedInvoices.length === 0}
            onClick={() => onHandleSyncBulkInvoice()}
          />
        </Box>
      </Grid>
    </>
  );
};

export default FilterInvoiceForm;
